<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<circle cx="12" cy="7" r="1.6" fill="currentColor"></circle>
		<rect x="10.6" y="10.2" width="2.8" height="8.8" rx="1.4" fill="currentColor"></rect>
	</svg>
</template>
